<template lang="pug">
v-dialog(v-model='dialog', :max-width='options.width', content-class='confirm-dialog')
  v-toolbar(dark, :color='options.color', dense)
    v-toolbar-title.white--text {{ title }}
  v-card(tile)
    v-card-text(v-show='!!message') {{ message }}
    v-card-actions.pa-4
      v-btn(@click.native='cancel') Annuleren
      v-spacer
      v-btn(:color='options.negativeColor', @click.native='negative') {{ options.negativeLabel }}
      v-btn(:color='options.positiveColor', @click.native='positive') {{ options.positiveLabel }}
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 450,
        positiveLabel: 'Ja',
        negativeLabel: 'Nee',
        positiveColor: 'primary',
        negativeColor: 'primary'
      }
    }
  },

  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    positive () {
      this.resolve(true)
      this.dialog = false
    },

    negative () {
      this.resolve(false)
      this.dialog = false
    },

    cancel () {
      this.reject('dialog closed')
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog {
  .v-card__text {
    white-space: pre-wrap;
  }
}
</style>
